let callbackQueue = [];
let messageName = 'zero-timeout-message';

window.addEventListener('message', function (e) {
	if (!(e.source === window && e.data === messageName)) {
		return;
	}

	e.stopPropagation();
	let start = performance.now();

	while (performance.now() - start < 5 && callbackQueue.length > 0) {
		try {
			callbackQueue.shift()();
		} catch (e) {
			console.error(e);
		}
	}

	if (callbackQueue.length > 0) {
		window.postMessage(messageName, '*');
	}
}, true);

export default function (fn) {
	callbackQueue.push(fn);

	if (callbackQueue.length === 1) {
		window.postMessage(messageName, '*');
	}
}
